<template>
  <div>
    <p>
      In the extrapolation simulation, you can choose to compute the link budget
      between the spacecraft and a set of ground stations. The ephemerides of
      the <b>link margin</b> and the
      <b>spacecraft elevation from the ground station</b> are made available by
      selecting `Link Budget` in the `Ephemerides generation`. You can also
      retrieve the dates of link budget events in the results.
    </p>

    <p>
      When choosing to simulate a link budget, the selected spacecraft must have
      an antenna with the RF fields defined. Similarly, these fields must also
      be filled in the selected ground stations.
    </p>
  </div>
</template>

<script>
export default {
  name: 'tooltipLinkBudget'
}
</script>
